module.exports = __webpack_public_path__ + "static/media/DSCF3890.8de2ac21.jpg";